import React from 'react';
import styled from 'styled-components';
import AppleLogo from '../SvgComponents/logos/AppleLogo';
import PlayStoreLogo from '../SvgComponents/logos/PlayStoreLogo';
import { CUSTOMER_APP } from '../../appLinks';

/* global tw */

const Group = styled.div`
    ${tw`inline-flex items-center`};
    gap: 0.4rem;
    ${props => props.hide && tw`flex lg:hidden xl:hidden`};
`

const IconPill = styled.a`
    ${tw`inline-flex items-center justify-center no-underline cursor-pointer`};
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 9999px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.10);
    color: #F5F5F7 !important;
    transition: all 0.2s ease;
    ${props => props.dark && `
        background: rgba(10, 10, 15, 0.04);
        color: #1A1A2E !important;
        border: 1px solid rgba(26, 26, 46, 0.18);
    `};
    &:hover {
        background: rgba(177, 92, 255, 0.12);
        border-color: rgba(177, 92, 255, 0.45);
    }
    &:active { transform: scale(0.95); }
`

class DownloadAppButtonMobile extends React.Component {
    handleClick = () => {
        // eslint-disable-next-line
        if (typeof analytics !== 'undefined') { analytics.track('Download App Clicked', { category: 'Download Button', label: 'Clicked' }); }
    }
    render() {
        const { dark, hide, className, iosUrl, androidUrl } = this.props;
        const ios = iosUrl || CUSTOMER_APP.ios;
        const android = androidUrl || CUSTOMER_APP.android;
        return (
            <Group hide={hide} className={className}>
                <IconPill href={ios} target="_blank" rel="noopener noreferrer" onClick={this.handleClick} dark={dark} aria-label="Download on the App Store">
                    <AppleLogo dark={dark} height="16" />
                </IconPill>
                <IconPill href={android} target="_blank" rel="noopener noreferrer" onClick={this.handleClick} dark={dark} aria-label="Get it on Google Play">
                    <PlayStoreLogo dark={dark} height="16" />
                </IconPill>
            </Group>
        );
    }
}

export default DownloadAppButtonMobile;
